import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import classNames from 'classnames';
import './Button.scss';

class PrimaryButton extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { id, onClick, content, disabled, className, name, variant, loading, icon } = this.props;
    return (
      <div className={classNames('primaryButton', className, variant)}>
        <Button
          id={id}
          name={name}
          onClick={onClick}
          content={content}
          disabled={disabled}
          loading={loading}
          icon={icon}
        />
      </div>
    );
  }
}

PrimaryButton.propTypes = {
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  loading: PropTypes.bool,
};

PrimaryButton.defaultProps = {
  disabled: false,
  variant: '',
  loading: false,
};

export default PrimaryButton;
